import { Container, Row, Col } from "react-bootstrap";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { ConsentModal } from "../../../modal/frontend/ConsentModal";
import { CalendarModal } from "../../../modal/CalendarModal";
import { ImgPreview } from "../../../model/datatype";
import { getImgCalendarCutoff } from "../../../services/ApiGetCalendarImgCutoff";
import { GetActivePurposes } from "../../../services/ApiConsent";
import { GetMenuItems } from "../../../../src/services/ApiMenuService";

interface MenuItemProps {
  id: number;
  IndexNo: number;
  menuSites: menuSites[];
  serviceNameEn: string;
  serviceNameTh: string;
  serviceNameVn: string;
  iconImageBase64: string;
  bgColor: string;
  linkUrl: string;
  eventHandler: string;
  isActive: boolean;
}

interface menuSites {
  menuId: number;
  site: string;
  active: boolean;
}

const sanitizeUrlParameter = (value: string): string => {
  // Remove any characters that could be used for XSS
  return encodeURIComponent(value.replace(/[^\w\s-]/gi, ''));
};

export const ServiceMenu = (props: any) => {
  const { t } = useTranslation();
  const [modalBackdrop, setModalBackdrop] = useState("true");
  const [modalKeyboard, setModalKeyboard] = useState(true);
  const [modalTitle, setModalTitle] = useState("");
  const [modalBody, setmodalBody] = useState("");
  const [modalConfirm, setModalConfirm] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showModal2, setShowModal2] = useState(false);
  const [data, setData] = useState<ImgPreview | null>(null);
  const [activePurposesRes, setActivePurposesRes] = useState([]);
  const [menuItems, setMenuItems] = useState<MenuItemProps[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (menuItems.length === 0) {
      setLoading(true);
      GetMenuItems()
        .then((response) => {
          const userGroup = sessionStorage.getItem('usergroup');
          const groupExists = userGroup?.includes(process.env.REACT_APP_SECGROUPS_CHECKIN!);
          
          //console.log('All menu items received:', response);
          
          // Filter for active menus and check menuSites active status
          const activeMenus = response.filter((menu: any) => {
            // Check if menu is active and has at least one active site
            const hasActiveSite = menu?.menuSites?.some((site: any) => site?.active === true);
            const isMenuActive = menu?.isActive === true && hasActiveSite;
            
            // console.log(`Menu ${menu?.id} (${menu?.serviceNameEn}):`, {
            //   isActive: menu?.isActive,
            //   hasActiveSite,
            //   isMenuActive,
            //   menuSites: menu?.menuSites
            // });
            
            return isMenuActive;
          });
          
          //console.log('Filtered active menus:', activeMenus);
          
          if (!groupExists) {
            const listOfMenu = activeMenus.filter((menu: any) => menu?.id !== 12);
            setMenuItems(listOfMenu);
            //console.log('Final menu list (without checkin):', listOfMenu);
          } else {
            setMenuItems(activeMenus);
            //console.log('Final menu list (with checkin):', activeMenus);
          }
          setLoading(false);
        })
        .catch((error) => {
          console.log("error get menu item", error);
          setLoading(false);
        });
    }
  }, [menuItems.length]);

  const handleShowModal = (e?: any) => {
    setShowModal(true);
  };

  const handleCloseModal = () => setShowModal(false);

  const handleLogout = () => {
    setShowModal2(false);
  };

  const handleOnExiting = () => { };

  useEffect(() => {
    if (data === null) {
      setLoading(true);
      getImgCalendarCutoff().then((response) => {
        const getData: any = response;
        setData(getData);
        setLoading(false);
      });
    }
    // GetActivePurposes().then((response) => {
    //   setActivePurposesRes(response);
    // });
  }, [data]);

  const handlePopupCalendar = (e: any) => {
    e.preventDefault();
    setModalTitle(t("CalendarPupup"));
    setmodalBody("data:image/jpg;base64," + data?.cutOffCalendar?.image);
    setModalBackdrop("true");
    setModalKeyboard(false);
    setModalConfirm(false);
    setShowModal2(true);
  };

  const handleLowCode = (e: any, item: any) => {
    //alert('xxxx');
  };

  const handleClick = (e: any, item: any) => {
    switch (item.eventHandler) {
      case "handlePopupCalendar":
        handlePopupCalendar(e);
        break;
      case "handleShowModal":
        handleShowModal(e);
        break;
      case "handleLowCode":
        handleLowCode(e, item);
        break;
      default:
        break;
    }
  };

  const generateHref = (item: MenuItemProps): string => {
    try {
          // ปลอดภัยต่อกรณี data ไม่ใช่ JSON ด้วย
      const raw = sessionStorage.getItem("GraphAccessToken") || "";

      // รูปแบบที่ปลอดภัย — จะลอง parse เป็น JSON ถ้าเป็นไปได้
      let accessToken = "";
      let expirationDate = null;

      try {
        const obj = JSON.parse(raw);
        accessToken = obj?.value || "";
        expirationDate = obj?.expirationDate || null;
      } catch (e) {
        // ถ้า parse ไม่ได้ ให้ถือว่า raw เป็น token เลย
        accessToken = raw;
      }

      //console.log("GraphAccessToken:", accessToken);
      const graphAccessToken = accessToken;
      const language = localStorage.getItem("Language") || "en";
      
      // If no linkUrl, return safe default
      if (!item.linkUrl) {
        return '#';
      }

      // Create URL object for safe URL manipulation
      const url = new URL(item.linkUrl.startsWith('http') ? item.linkUrl : `${window.location.origin}${item.linkUrl}`);
      
      // Only add parameters for handleLowCode
      if (item.eventHandler === "handleLowCode") {
        url.searchParams.append('AccessToken', graphAccessToken);
        url.searchParams.append('Language', sanitizeUrlParameter(language));
      }
      
      return url.toString();
    } catch (error) {
      console.error('Error generating href:', error);
      return '#';
    }
  };

  return (
    <>
      <CalendarModal
        btnConfirm="no"
        btnText="ปิด"
        type="images"
        keyboard={modalKeyboard}
        backdrop={modalBackdrop}
        confirm={modalConfirm}
        confirmFunc=""
        title={modalTitle}
        body={modalBody}
        showModal={showModal2}
        handleContinue={handleLogout}
        onExiting={() => handleOnExiting()}
        onHide={() => setShowModal2(false)}
        Style={{ background: "" }}
      />

      {/* <ConsentModal showModal={showModal} hideModal={handleCloseModal} /> */}

      {loading ? (
        <div className="layout-loading">
          <div className="lds-ring">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
      ) : (
        <div className="text-center time-detail-box ">
          <Container style={{ minHeight: "80vh", paddingBottom: "62px" }}>
            <Row>
              {menuItems.map((item, index) => (
                  <Col
                    className={`m-0  px-2 ${index % 2 === 0 ? "pe-0" : "pe-1"}`}
                    md={6}
                    xs={6}
                    lg={6}
                    key={item.id}
                  >
                    <a
                      href={generateHref(item)}
                      onClick={(e) => handleClick(e, item)}
                      title={"test"}
                    >
                      <div className="m-2 serviceMenu-item">
                        <p className={`mb-2 text-center pt-0`}>
                          <div
                            className="bg-cicle-uniform"
                            style={{ background: item.bgColor }}
                          >
                            <img
                              src={
                                "data:image/png;base64," + item?.iconImageBase64
                              }
                              height={50}
                              alt={item?.serviceNameEn}
                              style={{height:"40px"}}
                            />
                          </div>
                        </p>
                        <p className="mb-0" style={{ fontSize: "14px" }}>
                          {localStorage.getItem("Language") === "en"
                            ? item?.serviceNameEn
                            : item?.serviceNameTh}
                        </p>
                      </div>
                    </a>
                  </Col>
                ))}
            </Row>
          </Container>
        </div>
      )}
    </>
  );
};
